import { ChangeEvent, useMemo } from "react";

import { Select, SelectEvent } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { filterAndFindInstitution } from "./utils";
import { ReligiousAndMinorityInstitutionsDto } from "../../../../models/Institution/ReligiousAndMinorityInstitutionsDto";

interface IProps {
  selectedMinoritySchoolId: number | null;
  handleMinorityReligiousSchoolChange: (
    e: ChangeEvent<SelectEvent>,
    type: "minority" | "religious"
  ) => void;
  selectedReligiousSchoolId: number | null;
  religiousAndMinorityInstitutions?: ReligiousAndMinorityInstitutionsDto;
}

export const MinorityReligiousSelects = ({
  selectedMinoritySchoolId,
  handleMinorityReligiousSchoolChange,
  selectedReligiousSchoolId,
  religiousAndMinorityInstitutions,
}: IProps) => {
  const { t } = useTranslation();

  const {
    minorityInstitutions: rawMinorityInstitutions,
    religiousInstitutions: rawReligiousInstitutions,
  } = religiousAndMinorityInstitutions ?? {};

  const [minorityInstitutions, selectedMinorityInstitution] = useMemo(
    () =>
      filterAndFindInstitution(
        rawMinorityInstitutions,
        selectedMinoritySchoolId
      ),
    [rawMinorityInstitutions, selectedMinoritySchoolId]
  );

  const [religiousInstitutions, selectedReligiousInstitution] = useMemo(
    () =>
      filterAndFindInstitution(
        rawReligiousInstitutions,
        selectedReligiousSchoolId
      ),
    [rawReligiousInstitutions, selectedReligiousSchoolId]
  );

  return (
    <>
      {!!minorityInstitutions?.length && (
        <Row>
          <Col md={6}>
            <Select
              label={t("common.institutionDetails.nationalMinoritySchool")}
              value={selectedMinoritySchoolId}
              onChange={(e) =>
                handleMinorityReligiousSchoolChange(e, "minority")
              }
              selectData={codeBookToSelectData(minorityInstitutions)}
              required
              placeholder={selectedMinorityInstitution?.name}
            />
          </Col>
        </Row>
      )}
      {!!religiousInstitutions?.length && (
        <Row>
          <Col md={6}>
            <Select
              label={t("common.institutionDetails.religiousSchool")}
              value={selectedReligiousSchoolId}
              onChange={(e) =>
                handleMinorityReligiousSchoolChange(e, "religious")
              }
              selectData={codeBookToSelectData(religiousInstitutions)}
              required
              placeholder={selectedReligiousInstitution?.name}
            />
          </Col>
        </Row>
      )}
    </>
  );
};
